const isTokenExpired = (currentTime: number, loggedInTime: number, expiresIn: number) =>
    currentTime - loggedInTime >= expiresIn;

export default (loggedInTime: number, expiresIn: number) =>
    !isTokenExpired(Date.now(), loggedInTime, expiresIn);
